import Code from "../containers/Code";
import Login from "../containers/Login";

let SupportRoutes = [
    {
        path: '/support/login',
        forceAuth: false,
        container: Login,
        exact: false,
    },
    {
        path: '/support/code',
        forceAuth: false,
        container: Code,
        exact: false,
    }
]

export default SupportRoutes